var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
var MinValueCheckDirective = /** @class */ (function () {
    function MinValueCheckDirective() {
    }
    MinValueCheckDirective_1 = MinValueCheckDirective;
    MinValueCheckDirective.prototype.validate = function (control) {
        if (!control.value && control.value !== 0) {
            return undefined;
        }
        var value = +control.value;
        if (value < this.minNumber || value > this.maxNumber) {
            return { 'minValue': 'error' };
        }
        return undefined;
    };
    var MinValueCheckDirective_1;
    __decorate([
        Input()
    ], MinValueCheckDirective.prototype, "minNumber", void 0);
    __decorate([
        Input()
    ], MinValueCheckDirective.prototype, "maxNumber", void 0);
    MinValueCheckDirective = MinValueCheckDirective_1 = __decorate([
        Directive({
            selector: '[minValueCheck]',
            providers: [{
                    provide: NG_VALIDATORS,
                    useExisting: MinValueCheckDirective_1,
                    multi: true
                }]
        })
    ], MinValueCheckDirective);
    return MinValueCheckDirective;
}());
export { MinValueCheckDirective };
